import apiClient from '@/plugins/apiClient'
let basePath = "/settings";

export default {
    namespaced: true,
    state:{
         hasSettings: (sessionStorage.getItem('hasSettings') === 'true'),
         footer: sessionStorage.getItem('footer'),
         primary: sessionStorage.getItem('primary'),
         social: sessionStorage.getItem('social'),
         cookie: sessionStorage.getItem('cookie'),
         additionalcss: sessionStorage.getItem('additionalcss'),
         additionalbody: sessionStorage.getItem('additionalbody'),
         promolink: sessionStorage.getItem('promolink'),
    },
    getters:{
        hasSettings: state => state.hasSettings,
        footer: state => (state.footer) ? JSON.parse(state.footer) : null,
        primary: state => (state.primary) ? JSON.parse(state.primary) : null,
        social: state => (state.social) ? JSON.parse(state.social) : null,
        cookie: state => (state.cookie) ? JSON.parse(state.cookie) : null,
        promolink: state => (state.promolink) ? JSON.parse(state.promolink) : null,
        additionalcss: state => (state.additionalcss) ? JSON.parse(state.additionalcss) : null,
        additionalbody: state => (state.additionalbody) ? JSON.parse(state.additionalbody) : null,
    },
    mutations:{
        setFull(state, resp) {
            console.log('setFullSetting',resp)
            
            resp.data.forEach((element) => {
                state[element.slug] = JSON.stringify(element)
                sessionStorage.setItem(element.slug, JSON.stringify(element));
            });
            state.hasSettings = true;
            sessionStorage.setItem('hasSettings',true);
            console.log('setFullSetting', state);

        },
        setSingle(state, resp) {
            console.log('setSingleSetting',resp)
            state[resp.slug] = JSON.stringify(resp)
            sessionStorage.setItem(resp.slug, JSON.stringify(resp));
        },
        error(state, err) {
           state.hasSettings = false;
           console.error('error', err);
        }
    },
    actions:{
        getSettings({commit}, data){
            return new Promise((resolve, reject) => {
                 console.log('GET LIST :'+data)
                 apiClient.get(basePath+'/full').then(resp => {
                      commit('setFull', resp.data);
                      resolve(resp);
                  })
                  .catch(err => {
                      console.log('GET SINGLE', err)
                      commit('error', err);
                      reject(err);
                  });
            })
       },
       getSingleSettings({commit}, data){
        return new Promise((resolve, reject) => {
             console.log('GET Single :'+data)
             apiClient.get(basePath).then(resp => {
                  commit('setSingle', resp.data);
                  resolve(resp);
              })
              .catch(err => {
                  console.log('GET SINGLE', err)
                  commit('error', err);
                  reject(err);
              });
        })
   },
    }
}